import { render, staticRenderFns } from "./filePreview.vue?vue&type=template&id=2b49d2ce&scoped=true&"
import script from "./filePreview.vue?vue&type=script&lang=js&"
export * from "./filePreview.vue?vue&type=script&lang=js&"
import style0 from "./filePreview.vue?vue&type=style&index=0&id=2b49d2ce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b49d2ce",
  null
  
)

export default component.exports